@if (!loading) {
  <div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
      <a (click)="back()">
        <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
      </a>

      <div class="p-2 flex-grow-1 pl-2">
        <h1 class="text-dark text-center">
          {{ inSearchMode ? currentSearchTitle : 'Buscar turno por' }}
        </h1>
      </div>

      <div class="p-2 pl-2 help" (click)="openhelp()">
        <i class="bi bi-info-circle"></i>
      </div>
    </div>

    @if (helpOpen) {
      <div class="row m-3 p-3 align-items-start" id="tooltip-pwa" style="display:flex;">
        <div class="col-auto">
          <i class="bi bi-info-circle" style="font-size: 1.8em;"></i>
        </div>
        <div class="col">
          <div class="help-box">
            <div class="help-title">Podés buscar tu turno de tres maneras:</div>

            <div class="help-item">
              <i class="bi bi-clipboard-check"></i>
              <div>
                <strong>Por Especialidad</strong><br />
                Elegí una especialidad y luego la prestación para continuar.
              </div>
            </div>

            <div class="help-item">
              <i class="bi bi-person"></i>
              <div>
                <strong>Por Profesional</strong><br />
                Escribí al menos 3 letras para buscar un médico.
              </div>
            </div>

            <div class="help-item">
              <i class="bi bi-heart"></i>
              <div>
                <strong>Mis Médicos</strong><br />
                Accedé a profesionales con los que ya tuviste turnos.
              </div>
            </div>

            <div class="help-tip">
              💡 Podés cambiar la forma de búsqueda en cualquier momento.
            </div>
          </div>
        </div>
        <div class="col-auto" (click)="openhelp()">
          <i class="bi bi-x-lg" style="font-size: 1.4em;"></i>
        </div>
      </div>
    }

    <!--<div class="row filters fade-in tag-row">
      <div
        class="col filter"
        [ngClass]="{ 'filter-selected': showList === 'especialidad' }"
        (click)="selectFilter('especialidad')"
        id="busquedaEspecialidades">
        Especiaidad
      </div>

      <div
        class="col filter"
        [ngClass]="{ 'filter-selected': showList === 'prestador' }"
        (click)="selectFilter('prestador')"
        id="busquedaProfesionales">
        Profesional
      </div>

      <div
        class="col filter"
        [ngClass]="{ 'filter-selected': showList === 'miPrestador' }"
        (click)="selectFilter('miPrestador')"
        id="busquedaMisProfesionales">
        Mis Médicos
      </div>

      <div
        class="col filter"
        [ngClass]="{ 'filter-selected': showList === 'prestacion' }"
        (click)="selectFilter('prestacion')"
        id="busquedaPrestaciones">
        Prestaciones
      </div>
    </div>-->
    @if (!inSearchMode) {
      <div class="search-mode-selector fade-in">
        <button class="search-mode-card" (click)="selectFilter('especialidad')">
          <i class="bi bi-clipboard-check"></i>
          <span>Por Especialidad</span>
          <small>Elegí una especialidad y luego la prestación</small>
        </button>

        <button class="search-mode-card" (click)="selectFilter('prestador')">
          <i class="bi bi-person"></i>
          <span>Por Profesional</span>
          <small>Buscá por nombre o apellido del médico</small>
        </button>

        <button class="search-mode-card" (click)="selectFilter('miPrestador')">
          <i class="bi bi-heart"></i>
          <span>Mis Médicos</span>
          <small>Profesionales con los que ya tuviste turnos</small>
        </button>
      </div>
    } @else {
      <div class="search-mode-header fade-in">
        <button class="back-to-options-btn" (click)="backToSearchOptions()">
          <i class="bi bi-arrow-left"></i>
          <span>Cambiar forma de búsqueda</span>
        </button>
      </div>
    }

    <div class="row-cols-12 m-2">
      @if (showList === 'prestacion') {
        <div class="selected-path-chip">
          <i class="bi bi-clipboard-check"></i>
          <div class="chip-text">
            <span class="chip-title">
              Especialidad seleccionada: 
            </span>

            <small class="chip-subtitle">
              {{ especialidadSeleccionadaNombre }}
            </small>
          </div>
        </div>
        <div class="mt-4"><span>Ahora seleccioná una prestación</span></div>
      }

      @if (showSearchInput) {
        <div class="row-cols-12 p-2 input-group fade-in search-input-row">
          <div class="col-auto rounded-start" id="search-addon">
            <div class="mx-auto d-block p-1 d-inline-flex pt-1 ps-2">
              <i class="bi bi-search"></i>
            </div>
          </div>

          <div class="col rounded">
            <input
              type="text"
              class="form-control search-input shadow-none rounded"
              [placeholder]="searchPlaceholder"
              aria-label="Buscar"
              aria-describedby="search-addon"
              [value]="searchValue"
              (keyup)="onSearchKeyup($event)" />
          </div>
        </div>
      }

      <div class="resultSearch pb-3 mb-3">
        <!-- PRESTADORES -->
        @if (showList === 'prestador') {
          @for (prestador of ((prestadoresFiltrados$ | async) ?? []); track prestador.id) {
            <a
              class="result-card"
              [class.active]="isActivePrestador(prestador.id!)"
              (click)="savePrestador($event, prestador)"
            >
              <div class="result-icon">
                <i class="bi bi-person-fill"></i>
              </div>

              <div class="result-content">
                <div class="result-title text-truncate">
                  {{ prestador.x_apellido }} {{ prestador.x_nombre }}
                </div>

                @if (prestador.x_nro_matricula) {
                  <div class="result-subtitle text-truncate">
                    Matrícula: {{ prestador.x_nro_matricula }}
                  </div>
                }
              </div>

              <div class="result-arrow">
                <i class="bi bi-chevron-right"></i>
              </div>
            </a>
          }
          @if (
            showList === 'prestador' &&
            searchValue.length >= 3 &&
            ((prestadoresFiltrados$ | async)?.length === 0)
          ) {
            <div class="p-3 text-center text-detail-item">
              No se encontraron profesionales con ese nombre.
            </div>
          }
        }

        <!-- ESPECIALIDADES -->
        @if (showList === 'especialidad') {
          @for (especialidad of ((especialidadesFiltradas$ | async) ?? []); track especialidad.id) {
            <div
              class="result-card"
              [class.active]="isActiveEspecialidad(especialidad.id!)"
              (click)="saveEspecialidad($event, especialidad)"
            >
              <div class="result-icon">
                <i class="bi bi-clipboard"></i>
              </div>

              <div class="result-content">
                <div class="result-title text-truncate">
                  {{ especialidad.x_descripcion }}
                </div>

                <div class="result-subtitle">
                  Especialidad
                </div>
              </div>

              <div class="result-arrow">
                <i class="bi bi-chevron-right"></i>
              </div>
            </div>
          }
        }

        <!-- PRESTACIONES -->
        @if (showList === 'prestacion') {
          @for (prestacion of ((prestacionesFiltradas$ | async) ?? []); track prestacion.id) {
            <a
              class="result-card"
              [class.active]="isActivePrestacion(prestacion.id!)"
              (click)="savePrestacion($event, prestacion)"
            >
              <div class="result-icon">
                <i class="bi bi-ui-radios-grid"></i>
              </div>

              <div class="result-content">
                <div class="result-title text-truncate">
                  {{ prestacion.x_descripcion }}
                </div>

                @if (prestacion.descripcionEspecialidad) {
                  <div class="result-subtitle text-truncate">
                    {{ prestacion.descripcionEspecialidad }}
                  </div>
                }
              </div>

              <div class="result-arrow">
                <i class="bi bi-chevron-right"></i>
              </div>
            </a>
          }
        }

        <!-- MIS MEDICOS -->
        @if (showList === 'miPrestador') {
          @for (prestador of ((misPrestadoresFiltrados$ | async) ?? []); track prestador.id) {
            <a
              class="result-card"
              [class.active]="isActivePrestador(prestador.id!)"
              (click)="savePrestador($event, prestador)"
            >
              <div class="result-icon">
                <i class="bi bi-heart-fill"></i>
              </div>

              <div class="result-content">
                <div class="result-title text-truncate">
                  {{ prestador.x_apellido }} {{ prestador.x_nombre }}
                </div>

                @if (prestador.x_nro_matricula) {
                  <div class="result-subtitle text-truncate">
                    Matrícula: {{ prestador.x_nro_matricula }}
                  </div>
                }
              </div>

              <div class="result-arrow">
                <i class="bi bi-chevron-right"></i>
              </div>
            </a>
          }

          @if (((misPrestadoresFiltrados$ | async) ?? []).length === 0) {
            <div class="p-3 text-center text-detail-item">
              No tenés médicos con turnos previos.
            </div>
          }
        }

        @if (showList === null) {
          <div class="p-4 text-center text-detail-item">
            Seleccioná cómo querés buscar tu turno.
          </div>
        }
      </div>
    </div>

    @if (error) {
      <div class="alert alert-danger mt-2">{{ error }}</div>
    }
  </div>
} @else {
  <div class="wrapper fade-in">
    <div class="spinner-border text-info color-spinner" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
}